var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRechazar = function SvgRechazar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "rechazar_svg__Capa_2",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rechazar_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8",
    fill: "#ff4772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.04 10.96 5.92-5.92M5.04 5.04l5.92 5.92",
    fill: "none",
    stroke: "#ff4772",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgRechazar;